// extracted by mini-css-extract-plugin
module.exports = {"header__text-wrapper":"styles_header__text-wrapper__1k9QG","header__audio-wrapper":"styles_header__audio-wrapper__2bdXA"};